import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { ngHelper } from '@cakeiteasy/web-utils';
import { UiCakeCounterBaseComponent } from './ui-cake-counter-base.component';

/** Difference between ui-cake-counter and ui-single-pieces-counter:
 * ui-cake-counter is used in cake-builder footer, when cake-builder first init it should have some quantity
 * for product (it maybe increment or minQuantity) it is made for user usability,
 * it is better when user don't start with zero product quantity, while ui-single-pieces-counter is used on products overview
 * and in cake-multiple-variant-section where products quantity should be start with zero value, that's why
 * shiftCount and control disable logic a bit different
 * */

@Component({
  standalone: false,
  selector: 'ui-cake-counter',
  templateUrl: './ui-cake-counter.component.html',
  styleUrls: ['./ui-cake-counter.component.scss']
})
export class UiCakeCounterComponent extends UiCakeCounterBaseComponent implements OnChanges {
  ngOnChanges(changes: SimpleChanges): void {
    ngHelper.ifChanged(changes, 'minCount', (minCount) => {
      // set timeout to prevent expression changing on component init
      setTimeout(() => {
        if (!this.count || this.count < minCount) {
          this.changeCount(this.minCount);
        }
      });
    });
  }

  public minusDisablingCheck() {
    const minCount = this.minCountPerProduct || this.minCount;
    return this.count <= minCount;
  }

  public changeCount(newCount) {
    this.count = newCount;
    this.setCount(this.count);
  }

  public shiftCount(isIncrease: boolean) {
    const shift = this._getShift(isIncrease);
    const count = Math.max(0, this.count + shift);

    if (isIncrease) {
      this.count = this._hasMaxCount() && this.maxCount < count ? this.maxCount : count;
    } else {
      this.count = count < this.minCount ? this.minCount : count;
    }

    this.setCount(this.count);
  }
}
